<template>
  <div class="this-app-info">
    Version : {{version}}
  </div>
</template>

<script>
import cpPackage from '../../package'
export default {
  name: 'AppInfo',
  props: {},
  computed: {
    version: () => {
      return cpPackage.version;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';
  .this-app-info {
  }
</style>
